export const SUPPORT_FAQ_CATEGORY_ORDER = [
  "payments",
  "access-login",
  "privacy-consents",
  "deal-finder",
  "community-participation",
  "platform-linking",
];

export function buildFaqCategoryPath(category) {
  return `/support/faq/${category}`;
}

export function buildFaqArticlePath(category, slug) {
  return `${buildFaqCategoryPath(category)}/${slug}`;
}
